import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { SettingRoutingModule } from './setting-routing.module';
import { PermissionComponent } from './permission/permission.component';
import { NotificationConfigComponent } from './notification-config/notification-config.component';
import { NotificationLogsComponent } from './notification-logs/notification-logs.component';
import { WhatsappConfigComponent } from './whatsapp-config/whatsapp-config.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        PermissionComponent,
        NotificationConfigComponent,
        NotificationLogsComponent,
        WhatsappConfigComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        SettingRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
        AgGridModule,
        NgxDropzoneModule,
        AutocompleteLibModule
    ],
    providers: [DatePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingModule { }
